import Axios from "axios";
import { api_url } from "../../../../config";
import { normaliserErreurOperateur } from "../../Operateurs/operateursApi";

// ============================================================
// Appels /allocataires/:id/sous-orientation (CE-1370), en français comme le
// contrat de l'API. Les erreurs sont normalisées comme celles des opérateurs :
// 400 sous les champs (`champs`), sinon un `message`.
// ============================================================

const base = (allocataireId) => `${api_url}allocataires/${allocataireId}/sous-orientation`;

const appel = (promesse) =>
  promesse.then(
    (res) => res.data,
    (err) => Promise.reject(normaliserErreurOperateur(err))
  );

/** La sous-orientation de l'allocataire ; `null` s'il n'en a pas. */
export const voirSousOrientation = (allocataireId) => appel(Axios.get(base(allocataireId)));

/** `{ operateurId: string | null, motif }` : la sous-orientation relue. */
export const corrigerSousOrientation = (allocataireId, corps) => appel(Axios.put(base(allocataireId), corps));
